import React, { useState , useEffect} from 'react'
import { useOrderStore } from 'src/hooks/order';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import System from 'src/helper/system';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/helper/Helper';
import { useSystem } from 'src/hooks/system';
import Order from "@system/config/order";
import Constants from 'src/helper/Constants';

const OrderHistoryEmailPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t } = System;

    const { SetStatus, data } = props;
    const singleOrder = data.singleOrder
    const singleProduct = data.singleProduct
    const isFromOrderDetail = data?.isFrom === Constants.systemModules.ORDERDETAIL
    const { avUserInfoData: { email, accountNumber, userName } } = System

    const subject = t('inRegardToThePO') + (Helper.valueIsNotNull(singleOrder?.poNumber) ? singleOrder.poNumber : '') + ' - ' + singleProduct.mfrPartNumber + ' - ' + t('for') + ' ' + accountNumber + ' - ' + userName

    const initialState = {
        CC: '',
        message: ''
    }
    const [formData, SetFormData] = useState(initialState);
    const [validationError, setValidationError] = useState({ CCError: '', messageError: '' })
    const [{ }, { fetch_Order_Service_Rep_Email, send_Order_Item_Email }, { }] = useOrderStore();
    const [serviceRepMessage, setServiceRepMessage] = useState('')
    const [, { get_quantity_format }] = useSystem();

    const fromEmail = System.validateDomain(email) ? window.themeData?.userData?.mail : email
    const emailRegex = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/

    const OnSend = async () => {
        let error = false
        if (formData.CC.trim() !== '' && !formData.CC.match(emailRegex)) {
            setValidationError(prevState => ({ ...prevState, CCError: t('aValidEmailAddressIsRequired') }));
            error = true
        }
        if (formData.message.trim().length > 255) {
            setValidationError(prevState => ({ ...prevState, messageError: t('maximum255CharactersAllowed') }));
            error = true
        }

        if (!error && singleOrder && singleProduct) {
            __set('ORDER_LINE_ITEM_EMAIL_API_CALL')
            let res = await send_Order_Item_Email({
                orderDate: singleOrder.orderDate ? singleOrder.orderDate : '-',
                poNumber: singleOrder?.poNumber,
                webOrderNumber: singleOrder?.webOrderNum,
                orderNumber: singleOrder?.salesOrderNum,
                manufacturer: singleProduct.parentManufacturerName,
                manufacturerPartNumber: singleProduct.mfrPartNumber,
                customerPartNumber: singleProduct.custMatNum,
                quantity: Number(singleProduct.qty),
                cc: formData.CC.replace(/,/g, ";"),
                subject: subject,
                message: formData.message
            });

            __remove('ORDER_LINE_ITEM_EMAIL_API_CALL')

            if (res) {
                System.popup('OrderDetailEmailItemStatusPopup', { isSubmitted: true })
            }
            else {
                System.popup('OrderDetailEmailItemStatusPopup', { isSubmitted: false })
            }
        }
    }

    const onChange = (field, value) => {
        SetFormData({ ...formData, [field]: value });
    }

    useEffect(() => {
        const fetchEmail = async () => {
            const result = await fetch_Order_Service_Rep_Email();
            const toEmail = Helper.valueIsNotNull(result)
                ? result.replace(";", ", ")
                : "OnlineSupport-Asia@avnet.com";
            setServiceRepMessage(toEmail);
        };

        fetchEmail();
    }, []);


    return (
        <>
            <div className="avnet-modal modal-700">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="modal-title m-auto">{t('emailLineItemMessage')}</h3>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className='bs5 row'>

                            <div className='col-6'>
                                <p className='mb-3 font-16 font-arial text-uppercase'><strong> {t('orderInformation')}</strong></p>
                                {singleOrder &&
                                    <div className='font-13 font-arial'>
                                        <div>
                                            <b>{t('orderDate')}: </b> {singleOrder.orderDate ? Helper.orderHistoryDateFormat(singleOrder.orderDate) : '-'}
                                        </div>
                                        <div>
                                            <b>{t('pONumber')}: </b>{singleOrder?.poNumber?.trim() !== '' ? <a onClick={() => isFromOrderDetail ? SetStatus(false) : window.location.href = Order.getOrderDetailRouteURL({
                                                orderNumber: singleOrder?.azureOrderNum,
                                            })}>{singleOrder?.poNumber}</a> : '-'}
                                        </div>
                                        <div><b>{t('webOrderNumber')} : </b> <span className='text-blue2'>
                                            <a onClick={() => isFromOrderDetail ? SetStatus(false) : window.location.href = Order.getOrderDetailRouteURL({
                                                orderNumber: singleOrder?.azureOrderNum,
                                            })}>{singleOrder?.webOrderNum ? singleOrder?.webOrderNum : "-"}</a>
                                        </span></div>
                                        <div><b>{t('orderNumber')}: </b> {Number(singleOrder.salesOrderNum) > 0 ? singleOrder.salesOrderNum : "-"} </div>
                                    </div>
                                }
                            </div>
                            <div className='col-6'>
                                <p className='mb-3 font-16 font-arial text-uppercase'><strong>{t('partInformation')}</strong></p>
                                {
                                    singleProduct &&
                                    <div className='font-13 font-arial'>
                                        <div><b>{t('manufacturer')}: </b> {singleProduct.parentManufacturerName ? singleProduct.parentManufacturerName : '-'}</div>
                                        <div><b>{t('manufacturerPartNumber')}: </b> {singleProduct.mfrPartNumber ? singleProduct.mfrPartNumber : '-'}</div>
                                        <div><b>{t('customerPartNumber')}: </b> {singleProduct.custMatNum ? singleProduct.custMatNum : '-'}</div>
                                        <div><b>{t('quantity')}: </b> {singleProduct.qty ? get_quantity_format(singleProduct.qty) : '-'}</div>
                                    </div>
                                }
                            </div>
                        </div>

                        <hr />

                        <div className='font-13 font-arial mb-3'>
                            <div><b>From: </b> {fromEmail}</div>
                            <div><b>To: </b> {serviceRepMessage}</div>
                        </div>

                        <div className="form-group">
                            <label htmlFor='CC'>CC</label>
                            <input type="text" name="CC"
                                className="form-control form-control-sm" placeholder=""
                                onChange={({ target: { value } }) => onChange("CC", value)} />
                            <p className="error">{validationError.CCError.trim().length > 0 && validationError.CCError}</p>
                        </div>
                        <div className="form-group mt-4">
                            <div className='bg-grey2 p-2'>
                                <label htmlFor="Subject"><b>Subject:</b> {subject}</label>
                            </div>
                        </div>
                        <div className="form-group mb-4">
                            <label htmlFor="Message"><b>{t('message')}</b></label>
                            {
                                <> <textarea name="name" rows="8" cols="60" className="form-control form-control-sm"
                                    placeholder={t('typeYourMessage')} maxLength={255}
                                    onChange={({ target: { value } }) => onChange("message", value)}></textarea>
                                    <p className='pull-right d-block mt-2 w-100 text-end text-black-stone'><i>{t('charactersRemaining')} {255 - formData.message.trim().length > 0 ? 255 - formData.message.trim().length : 0}/255</i></p>
                                    <p className="error">{validationError.messageError.trim().length > 0 && validationError.messageError} </p>
                                </>
                            }

                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center d-flex">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={() => {
                                SetStatus(false)
                            }}>
                                {t('cancel')}
                            </button>
                            {__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status &&

                                <button type="button" className="bs5 btn btn-primary btn-sm w145 disabled" data-dismiss="modal"
                                    onClick={(() => e.preventDefault())}>
                                    <i className="fa fa-spinner fa-spin" />
                                </button>
                            }

                            {!__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status &&

                                <button type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                                    onClick={(() => OnSend())}>
                                    {t('send')}
                                </button>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderHistoryEmailPopup